export default "__VITE_ASSET__BIGfpzG7__"